import { render, staticRenderFns } from "./ControlPagoDocentePorEmpresaPage.vue?vue&type=template&id=ef65edc4&scoped=true"
import script from "./ControlPagoDocentePorEmpresaPage.vue?vue&type=script&lang=js"
export * from "./ControlPagoDocentePorEmpresaPage.vue?vue&type=script&lang=js"
import style0 from "./ControlPagoDocentePorEmpresaPage.vue?vue&type=style&index=0&id=ef65edc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef65edc4",
  null
  
)

export default component.exports